<div class="card card-custom">
    <div class="d-flex justify-content-between">
        <div class="card-header d-flex align-items-center flex-wrap">
            <h3 class="card-title align-items-start flex-column">
                <span class="font-weight-bolder text-dark">
                    {{"WidgetPersonnelGraph" | localize}}
                </span>
            </h3>
        </div>
        <div class="d-flex">
            <div class="d-flex align-items-center">
                <label class="col d-block mb-0" for="Personnel_Name">{{ "Name" | localize }}</label>
                <div class="col-sm-12">
                    <mat-form-field>
                        <mat-select [formControl]="nameFormCtrl"
                                    [multiple]="true"
                                    #managerSelector
                                    (selectionChange)="selectedName($event)">
                            <mat-option *ngFor="let name of names"
                                        [value]="name.staffId">
                                        {{name.contactDetails.firstName }} {{name.contactDetails.lastName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex align-items-center">
                <label class="col d-block mb-0" for="Personnel_Manager">{{ "Manager" | localize }}</label>
                <div class="col-sm-12">
                    <mat-form-field>
                        <mat-select [formControl]="managerFormCtrl"
                                    [multiple]="true"
                                    #managerSelector
                                    (selectionChange)="selectedManager($event)">
                            <mat-option *ngFor="let manager of managers"
                                        [value]="manager.staffId">
                                        {{manager.contactDetails.firstName }} {{manager.contactDetails.lastName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body" [perfectScrollbar]>
        <div class="row">
            <div class="col" style="max-height: 200px">
                <ngx-charts-bar-vertical-stacked [results]="chartData" [xAxis]="showXAxis" [scheme]="scheme">
                    <ng-template #tooltipTemplate let-model="model">
                        <span>{{model.name}}</span>
                        <br />
                        <span>{{model.value}}</span>
                    </ng-template>
                </ngx-charts-bar-vertical-stacked>
            </div>
        </div>
    </div>
</div>